import React, { useContext, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { MultipleMenu, Logout } from "../components/sidebar";
import { DrawerContext } from "../context/Drawer";
import data from "../data/master/sidebar.json";

export default function Sidebar() {
  const { drawer } = useContext(DrawerContext);
  const { pathname } = useLocation();
  const asideRef = useRef(null);

  /* PageLayout is rendered inside every route → the sidebar re-mounts
   * on every navigation and its overflow-y:scroll container defaults
   * back to scrollTop=0. When a shopper (admin) clicks an item near the
   * bottom of a long sidebar, the next page re-renders with the item
   * scrolled off-screen — they have to manually scroll to find where
   * they were.
   *
   * Fix: after mount, find the currently-active item and scroll it into
   * view inside the sidebar container (not the page). `focused` is set
   * on top-level leaves, `active` inside dropdowns — try both. */
  useEffect(() => {
    if (!asideRef.current) return;
    const el =
      asideRef.current.querySelector(".mc-sidebar-dropdown-item.active") ||
      asideRef.current.querySelector(".mc-sidebar-menu-item.focused");
    if (!el) return;
    /* rAF so the browser has laid out the sidebar before we measure. */
    requestAnimationFrame(() => {
      const container = asideRef.current;
      if (!container) return;
      const cRect = container.getBoundingClientRect();
      const eRect = el.getBoundingClientRect();
      const delta = eRect.top - cRect.top - (container.clientHeight / 2 - el.clientHeight / 2);
      container.scrollTop = Math.max(0, container.scrollTop + delta);
    });
  }, [pathname]);

  return (
    <aside
      ref={asideRef}
      className={`mc-sidebar thin-scrolling ${drawer ? "active" : ""}`}
    >
      <MultipleMenu data={data?.navs} />
      <Logout data={data?.button}  />
    </aside>
  );
}
